import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { useState } from "react";

const faqs = [
  {
    q: "What types of customisation does Emcee Sons offer for diaries?",
    a: "We offer three types of customisation for bulk orders: 1) Gold Foiling with company logo and personalised name, 2) Page Insertions with custom company pages, brochures, or calendars, and 3) Fully Customised Diaries designed from scratch for orders of 2000+ units — including cover material, paper quality, layout, and binding.",
  },
  {
    q: "What is the minimum order quantity for customised diaries?",
    a: "Gold foiling and page insertions are available for any bulk order quantity. Fully customised diaries (designed from scratch) require a minimum order of 2000 units. Contact us on WhatsApp at +91 93437 16059 for exact pricing.",
  },
  {
    q: "Where is Emcee Sons located in Bengaluru?",
    a: "We're at 29, Avenue Road, inside Sri Krishna Building, opposite to SBI, Cubbonpete, Nagarathpete, Bengaluru 560002. Open Monday to Saturday, 10:30 AM to 8:30 PM.",
  },
  {
    q: "What diary brands does Emcee Sons stock?",
    a: "We are the Super Stockist for Eagle Diaries, one of India's most trusted diary brands. We carry 50+ variants including Perfect Diary, Project Diary, Wings Diary, Span Diary, Club Diary, Embassy Diary, and various notebooks and planners.",
  },
  {
    q: "How do I place a bulk order for corporate diaries?",
    a: "You can place bulk orders by visiting our showroom on Avenue Road, calling us at +91 93437 16059, or messaging us on WhatsApp. We offer competitive pricing for bulk corporate orders with customisation options.",
  },
  {
    q: "Does Emcee Sons deliver diaries across India?",
    a: "Yes, we deliver premium Eagle Diaries across India for bulk and corporate orders. Contact us on WhatsApp or phone to discuss delivery options and timelines for your location.",
  },
];

const FAQItem = ({ faq, isOpen, onToggle, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 15 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.4, delay: index * 0.06 }}
    className="border-b border-black/5 last:border-0"
  >
    <button
      onClick={onToggle}
      data-testid={`faq-toggle-${index}`}
      className="w-full flex items-center justify-between py-6 text-left gap-4 group"
    >
      <h3
        className="text-base text-[#1A1A1A] pr-4 group-hover:text-[#7A1A31] transition-colors"
        style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 500 }}
      >
        {faq.q}
      </h3>
      <ChevronDown
        className={`w-5 h-5 text-[#C8A23A] flex-shrink-0 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
      />
    </button>
    <div
      className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-60 pb-6" : "max-h-0"}`}
    >
      <p
        className="text-sm text-[#6B7280] leading-relaxed pr-10"
        style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300 }}
        data-testid={`faq-answer-${index}`}
      >
        {faq.a}
      </p>
    </div>
  </motion.div>
);

export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="py-24 sm:py-32 bg-white relative">
      <div className="container mx-auto px-6 sm:px-8 max-w-3xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-14"
        >
          <span
            className="text-xs tracking-[0.2em] uppercase font-semibold text-[#C8A23A] mb-4 block"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            FAQ
          </span>
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#1A1A1A]"
            style={{ fontFamily: "'Playfair Display', serif" }}
            data-testid="faq-heading"
          >
            Frequently Asked <span className="text-[#7A1A31]">Questions</span>
          </h2>
        </motion.div>

        <div className="bg-[#FAFAF7] rounded-2xl border border-black/5 px-6 sm:px-10">
          {faqs.map((faq, i) => (
            <FAQItem
              key={i}
              faq={faq}
              index={i}
              isOpen={openIndex === i}
              onToggle={() => setOpenIndex(openIndex === i ? -1 : i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
